import { useLayoutEffect } from 'react';

//fix overscroll color
export function useBlueBody(){
    useLayoutEffect(() => {
        document.body.classList.add('blue-bg');
        return () => {
          document.body.classList.remove('blue-bg');
        };
      }, []);
}
